import { ApiResource } from './apiResource';

export class HospPharmacyApi extends ApiResource {
  async list(params: any) {
    return this.client.get(`/admin/external/HospPharmacyOpCloList`, params);
  }
}
